import { createFileRoute } from '@tanstack/react-router';
import { Lock } from 'lucide-react';

import { useTranslation } from '@/utils/i18n';

/**
 * Collection screen — ported from the legacy `(tabs)/collection.tsx`, a
 * "coming soon" teaser: title + collectible-cards artwork blurred behind a
 * lock chip and copy. (Wireframe 6's full rewards collection is a future
 * design; RN is the source of truth.)
 */
export const Route = createFileRoute('/_tabs/collection')({
  component: CollectionScreen,
});

function CollectionScreen() {
  const { t } = useTranslation();

  return (
    <div
      className="tw:relative tw:flex tw:h-full tw:flex-col tw:overflow-hidden tw:pb-[var(--tab-bar-inset,0px)]"
      data-testid="screen-collection"
    >
      <h1 className="tw:relative tw:z-10 tw:px-5 tw:py-5 tw:heading-2 tw:text-white">
        {t('collection.title')}
      </h1>

      {/* Collectible cards artwork */}
      <img
        src="/images/collection-cards.png"
        alt=""
        aria-hidden="true"
        className="tw:absolute tw:inset-x-0 tw:top-20 tw:h-64 tw:w-full tw:object-cover"
      />

      {/* Blur + dim overlay */}
      <div className="tw:absolute tw:inset-0 tw:top-[104px] tw:bg-black/50 tw:backdrop-blur-md" />

      {/* Coming-soon content */}
      <div className="tw:relative tw:z-10 tw:mt-10 tw:flex tw:flex-col tw:items-center tw:gap-4 tw:px-8 tw:text-center">
        <span className="tw:flex tw:items-center tw:gap-1.5 tw:rounded-full tw:border tw:border-error/50 tw:bg-error/20 tw:px-3 tw:py-1.5 tw:text-[13px] tw:font-semibold tw:text-white">
          <Lock size={14} />
          {t('common.comingSoon')}
        </span>
        <p className="tw:text-base tw:font-semibold tw:text-white">
          {t('collection.comingSoonTitle')}
        </p>
        <p className="tw:text-base tw:font-semibold tw:text-grey-2">
          {t('collection.comingSoonDescriptionQuestion')}
        </p>
        <p className="tw:text-base tw:font-semibold tw:text-grey-2">
          {t('collection.comingSoonDescriptionSurprise')}
        </p>
      </div>
    </div>
  );
}
